export const SET_FORCE_PRINT = 'DashboardOptions/SET_FORCE_PRINT';